/**
 * Tuned QueryClient for the app.
 *
 * Defaults are picked for a mobile-first social app:
 * - `staleTime: 30s`  -> avoid refetch storms when remounting screens.
 * - `gcTime: 5min`    -> keep recently-used data warm for back-navigation.
 * - `refetchOnWindowFocus: false` -> intrusive on web, no-op in Capacitor.
 * - `retry: 1`        -> one quick retry, then surface the error.
 *
 * Per-query overrides (e.g. realtime-ish notifications, long-lived
 * landing-page data) should be set on the individual `useQuery` call.
 */
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      // Revalidate when the user returns to the tab/app. Combined with the
      // Capacitor appStateChange listener in useAppForegroundRefresh, this
      // keeps Home/Discover fresh on native without waiting for staleTime.
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
